import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { clsx } from 'clsx';

interface ErrorMessageProps {
  message?: string;
  className?: string;
  variant?: 'default' | 'inline' | 'prominent';
  showIcon?: boolean;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  className,
  variant = 'default',
  showIcon = true
}) => {
  if (!message) return null;

  const baseClasses = 'text-sm flex items-start gap-1.5';
  
  const variantClasses = {
    default: 'mt-1 p-2 bg-destructive/5 border border-destructive/15 rounded-md text-destructive',
    inline: 'mt-1 p-2 bg-destructive/5 border border-destructive/15 rounded-md text-destructive',
    prominent: 'mt-2 p-3 bg-destructive/10 border border-destructive/20 rounded-lg text-destructive'
  };

  const iconClasses = {
    default: 'h-4 w-4 mt-0.5 flex-shrink-0',
    inline: 'h-4 w-4 mt-0.5 flex-shrink-0',
    prominent: 'h-4 w-4 mt-0.5 flex-shrink-0'
  };

  return (
    <div className={clsx(baseClasses, variantClasses[variant], className)}>
      {showIcon && (
        <ExclamationCircleIcon className={iconClasses[variant]} />
      )}
      <span className="leading-tight">{message}</span>
    </div>
  );
};

export default ErrorMessage;